import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import SearchCard from './SearchCard.vue';
import SearchItem from './SearchItem.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchList',
  props: {
    items: null,
    title: null,
    ctaLabel: null,
    ctaLink: null,
    query: null,
    category: null
  },
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers;

    /**
     * Highlights the searched word in a given text.
     *
     * @param {string} text - The original text where the search occurs.
     * @param {string} keyword - The word to highlight.
     * @returns {string} - The text with the keyword wrapped in <strong>.
     */
    function highlightKeyword(text, keyword) {
      if (!keyword.trim()) return text;
      var regex = new RegExp("(".concat(keyword, ")"), 'gi');
      return text.replace(regex, '<strong>$1</strong>');
    }
    function closeSearch(type, term, result, index) {
      $trackers.gtm.pushEvent('overlay_search', {
        event: 'generic_event',
        event_action: 'send',
        event_category: 'engagement',
        event_label: type,
        event_name: 'search_overlay',
        search_term: term,
        search_result_name: result || "button-redirection-".concat(type),
        index: index || "button-redirection-".concat(type)
      });
      emit('close');
    }
    return {
      __sfc: true,
      props: props,
      $trackers: $trackers,
      emit: emit,
      highlightKeyword: highlightKeyword,
      closeSearch: closeSearch,
      SearchCard: SearchCard,
      SearchItem: SearchItem,
      AzButton: AzButton,
      AzIcon: AzIcon
    };
  }
});